import { Inject, Injectable, Injector } from '@angular/core';

import { CatalogoResponse } from '../../../models/catalogo.models';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import {
  Environment,
  ENVIRONMENT_TOKEN,
} from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { VendedorSelectService } from '../vendedor-service/vendedor-service.service';

@Injectable({
  providedIn: 'root',
})
export class NewApiCatalogoService extends UtilsBaseApiService<NewApiCatalogoService> {
  readonly CATALOGO_EXTENSION = 'catalogo';
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
    private readonly vendedorSelectUser: VendedorSelectService,
  ) {
    super('home', injector, environment.BASE_API_URL);
  }

  searchDepartment() {
    const queryString = this.getQueryString({
      idvend: this.vendedorSelectUser.vendedorActiv(),
    });

    return this.httpClient.get<CatalogoResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.CATALOGO_EXTENSION}?${queryString}`,
    );
  }
}
